import * as React from "react";
import { SVGProps } from "react";
export const PhoneIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M16.646 17.5C14.8267 17.5 13.0663 17.104 11.365 16.312C9.663 15.5207 8.156 14.4687 6.844 13.156C5.53133 11.844 4.47933 10.337 3.688 8.635C2.896 6.93367 2.5 5.17333 2.5 3.354C2.5 3.118 2.58667 2.91667 2.76 2.75C2.934 2.58333 3.139 2.5 3.375 2.5H6.833C7.02767 2.5 7.198 2.56267 7.344 2.688C7.48933 2.81267 7.576 2.97233 7.604 3.167L8.188 6.146C8.21533 6.32667 8.20833 6.49333 8.167 6.646C8.125 6.79867 8.04867 6.93067 7.938 7.042L5.917 9.104C6.44433 10.0487 7.142 10.9583 8.01 11.833C8.878 12.7083 9.833 13.4583 10.875 14.083L12.833 12.083C12.9723 11.9443 13.1253 11.8507 13.292 11.802C13.4587 11.7533 13.639 11.743 13.833 11.771L16.833 12.396C17.0277 12.424 17.1873 12.5107 17.312 12.656C17.4373 12.802 17.5 12.9723 17.5 13.167V16.625C17.5 16.861 17.4167 17.066 17.25 17.24C17.0833 17.4133 16.882 17.5 16.646 17.5ZM5.083 7.438L6.396 6.125L6.042 4.25H4.292C4.36133 4.80533 4.455 5.34367 4.573 5.865C4.691 6.38567 4.861 6.91 5.083 7.438ZM15.75 15.708V13.958L13.833 13.562L12.521 14.917C13.0623 15.125 13.597 15.2917 14.125 15.417C14.653 15.5417 15.1947 15.6387 15.75 15.708Z"
            fill="currentColor"
        />
    </svg>
);
PhoneIcon.displayName = "PhoneIcon";
